var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFromTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.16344 0 0 7.27537 0 16.25V48.75C0 57.7246 7.16344 65 16 65H48C56.8366 65 64 57.7246 64 48.75V16.25C64 7.27537 56.8366 0 48 0Z",
    fill: "#FFE0C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 12.5,
    width: 17,
    height: 16,
    rx: 3.5,
    stroke: "#5C442A",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 12.5,
    width: 17,
    height: 16,
    rx: 3.5,
    stroke: "#5C442A",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 36.5,
    width: 17,
    height: 16,
    rx: 3.5,
    stroke: "#5C442A",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7445 32.6355C35.0936 33.2093 34.2064 35.0419 34.7803 36.6928L38.9013 48.5483L38.0029 48.0867L37.6756 47.9541C36.9242 47.5924 36.0602 47.5431 35.2725 47.8169C34.4848 48.0907 33.8376 48.6653 33.4726 49.4151C33.1109 50.1665 33.0615 51.0306 33.3353 51.8183C33.6092 52.606 34.1838 53.2531 34.9336 53.6182L34.9444 53.6493L45.9855 58.916L46.0585 58.9254L46.1116 58.9778C47.9363 59.5706 49.9045 59.5526 51.7181 58.9266L53.4443 58.3266C54.5248 57.9535 55.521 57.3707 56.3756 56.6117C57.2303 55.8526 57.9266 54.9322 58.4247 53.9033C58.9227 52.8744 59.2126 51.7573 59.2777 50.616C59.3429 49.4748 59.182 48.3319 58.8043 47.2531L56.079 39.413C55.5052 37.7621 53.6716 36.8752 52.0217 37.4487C51.5941 37.5974 51.2395 37.8522 50.9274 38.1452C50.1447 36.955 48.6153 36.3831 47.2152 36.8698C46.4465 37.137 45.8456 37.6833 45.4805 38.3513C44.7576 38.0407 43.9451 38.0101 43.2009 38.2652C42.8594 38.3887 42.542 38.5706 42.2628 38.8027L40.8018 34.5997C40.228 32.9488 38.3954 32.0616 36.7445 32.6355ZM37.4422 34.6427C37.9992 34.449 38.601 34.7404 38.7946 35.2974L42.6321 46.3369L44.6393 45.6392L43.2438 41.6249C43.0502 41.0679 43.3416 40.466 43.8986 40.2724C44.4556 40.0788 45.0574 40.3701 45.251 40.9271L46.6465 44.9415L48.6536 44.2438L47.2582 40.2294C47.0646 39.6724 47.356 39.0706 47.913 38.877C48.47 38.6834 49.0718 38.9747 49.2654 39.5317L50.6608 43.5461L52.7624 42.8156L52.0646 40.8084C51.871 40.2514 52.1624 39.6496 52.7194 39.4559C53.2754 39.2627 53.8782 39.5537 54.0718 40.1107L56.7975 47.9518C58.0059 51.4282 56.223 55.111 52.7456 56.3198L51.0214 56.9191C49.5511 57.4302 48.0981 57.3469 46.7678 56.9207L35.8538 51.7156C35.252 51.4243 35.0828 50.9375 35.3741 50.3357C35.6665 49.7335 36.1522 49.5646 36.7541 49.856L42.5872 52.6799L36.7874 35.9951C36.5938 35.4381 36.8852 34.8363 37.4422 34.6427Z",
    fill: "#5C442A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFromTemplateIcon);
export default __webpack_public_path__ + "static/media/selectFromTemplateIcon.10decdabe9a5417bc9b9fbbf2e100d8d.svg";
export { ForwardRef as ReactComponent };